export var MouseEnterTipsViewUtil;
(function (MouseEnterTipsViewUtil) {
    let target = null;
    function getElement() {
        const mouseEnterTipsViewElement = document.querySelector('#mouse-enter-tips-view');
        return mouseEnterTipsViewElement;
    }
    let showTimeoutId = null;
    /**
     * MouseEnter時に Tips を表示。
     * @param mouseEvent
     * @param text
     */
    function show(mouseEvent, text) {
        const mouseEnterTipsViewElement = getElement();
        if (mouseEnterTipsViewElement == null) {
            console.error('#mouse-enter-tips-view が用意できていません');
            return;
        }
        const textElement = mouseEnterTipsViewElement.querySelector('.text');
        textElement.innerText = text;
        target = mouseEvent.target;
        // フォーカスを離れたら Tips を非表示にするイベントを設定
        addMouseLeaveEvent();
        // バルーンの表示
        // innerText が設定できて、 width が確定できてから表示するため、100ms タイミングをずらす
        showTimeoutId = setTimeout(() => {
            showTimeoutId = null;
            setupBalloonSize();
            showBalloon();
        }, 100);
    }
    MouseEnterTipsViewUtil.show = show;
    /**
     * balloonのサイズ設定
     * @private
     */
    function setupBalloonSize() {
        const mouseEnterTipsViewElement = getElement();
        if (mouseEnterTipsViewElement == null) {
            return;
        }
        const arrowElements = mouseEnterTipsViewElement.querySelectorAll('.arrow');
        const targetBoundingClientRect = target.getBoundingClientRect();
        const mouseEnterTipsViewBoundingClientRect = mouseEnterTipsViewElement.getBoundingClientRect();
        const mouseEnterTipsViewBoundingClientRectWidth = mouseEnterTipsViewBoundingClientRect.width;
        const targetBoundingClientRectWidth = targetBoundingClientRect.width;
        const targetLeft = targetBoundingClientRect.x + window.scrollX;
        const targetTop = targetBoundingClientRect.y + window.scrollY;
        const targetBottom = targetTop + targetBoundingClientRect.height;
        let mouseEnterTipsViewLeft = targetLeft - (mouseEnterTipsViewBoundingClientRectWidth * 0.5) + (targetBoundingClientRectWidth * 0.5);
        let offsetMouseEnterTipsViewLeft = 0;
        // 左端からはみ出た時に調整
        if (mouseEnterTipsViewLeft < 0) {
            offsetMouseEnterTipsViewLeft = mouseEnterTipsViewLeft * -1;
            mouseEnterTipsViewLeft = 0;
        }
        // 右端からはみ出た時に調整
        const bodyWidth = document.body.clientWidth;
        // console.log({currentTarget, bodyWidth});
        const mouseEnterTipsViewRight = mouseEnterTipsViewLeft + mouseEnterTipsViewBoundingClientRectWidth;
        if (mouseEnterTipsViewRight > bodyWidth) {
            offsetMouseEnterTipsViewLeft = (mouseEnterTipsViewRight - bodyWidth) * -1;
            mouseEnterTipsViewLeft = (bodyWidth - mouseEnterTipsViewBoundingClientRectWidth);
        }
        const mouseEnterTipsViewTop = targetBottom + 5; // 5 は吹き出しとの余白
        mouseEnterTipsViewElement.style.left = `${mouseEnterTipsViewLeft}px`;
        mouseEnterTipsViewElement.style.top = `${mouseEnterTipsViewTop}px`;
        let arrowLeft = (mouseEnterTipsViewBoundingClientRectWidth * 0.5) - 10 - offsetMouseEnterTipsViewLeft; // 10 は矢印の幅の半分
        for (let arrowElement of arrowElements) {
            arrowElement.style.left = `${arrowLeft}px`;
        }
    }
    /**
     * バルーンの表示
     * MouseEnterTipsView からも呼び出される
     */
    function showBalloon() {
        // console.log('showBalloon');
        const mouseEnterTipsViewElement = getElement();
        if (mouseEnterTipsViewElement == null) {
            return;
        }
        mouseEnterTipsViewElement.classList.add('show');
    }
    MouseEnterTipsViewUtil.showBalloon = showBalloon;
    /**
     * バルーンを非表示にする
     *
     */
    function hideBalloon() {
        if (showTimeoutId != null) {
            // バルーンの表示を setTimeout で予定されている場合は取り消す
            clearTimeout(showTimeoutId);
        }
        const mouseEnterTipsViewElement = getElement();
        if (mouseEnterTipsViewElement == null) {
            return;
        }
        mouseEnterTipsViewElement.classList.remove('show');
    }
    MouseEnterTipsViewUtil.hideBalloon = hideBalloon;
    /**
     * マウスを離れた時のイベントを設定
     * @private
     */
    function addMouseLeaveEvent() {
        target.addEventListener('mouseleave', onMouseLeave);
    }
    /**
     * マウスを離れた時に動くイベント。バルーンを非表示にする
     * @private
     */
    function onMouseLeave() {
        hideBalloon();
        // const textElement: HTMLElement = mouseEnterTipsViewElement.querySelector('.text') as HTMLElement;
        // textElement.innerText = '';
        target.removeEventListener('mouseleave', onMouseLeave);
    }
})(MouseEnterTipsViewUtil || (MouseEnterTipsViewUtil = {}));
